// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VideoPlayer from 'vue-video-player'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import 'lib-flexible'
import foot from './components/Footer.vue'
import head from './components/Header.vue'

Vue.component('v-foot', foot)
Vue.component('v-head', head)

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

Vue.use(Element)
 
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js